module.exports = __webpack_public_path__ + "img/location.d2aef0c1.jpg";